<section class="contact-page">
  <div class="container">
    <div class="section-head text-center">
      <h2>contact us</h2>
      <p>we are here to help with pickup, pricing, and service questions.</p>
    </div>

    <div class="contact-card">
      <div class="contact-item">
        <h3>phone</h3>
        <p>404 944 6670</p>
      </div>

      <div class="contact-item">
        <h3>website</h3>
        <p>www.dryocleaners.com</p>
      </div>

      <div class="contact-item">
        <h3>address</h3>
        <p>1270 w peachtree st nw, suite 2, atlanta, ga 30309</p>
      </div>
    </div>
  </div>
</section>
